module.exports = __webpack_public_path__ + "static/media/valikko-maankaytto.3f9a7140.jpg";